<script setup lang="ts">
import EstateListingWithMap from '~/components/estate/map/EstateListingWithMap.vue'

const { t } = useI18n()

useHead({
  title: t('pages.estateListing.header.titles.retailMap'),
  meta: [
    {
      name: 'description',
      content: t('pages.estateListing.header.descriptions.retail'),
    },
  ],
})

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/retail/map',
    sk: '/obchodne-priestory/mapa',
  },
})
</script>

<template>
  <EstateListingWithMap key="retail" estate-type="retail" />
</template>
